// Textos de la pantalla «Integraciones» (doc 0440). El catálogo de claves lo manda el backend; aquí
// solo se dice qué es cada una, para qué sirve y dónde conseguirla.

export const PROVIDER_INFO = {
  meta: {
    title: "Meta — Facebook y WhatsApp oficial",
    icon: "facebook",
    what: "La app de Meta de tu plataforma. Activa el botón «Conectar con Facebook» de Messenger y el registro integrado de WhatsApp oficial. Sin ella, esas conexiones solo se pueden crear con el método manual.",
    where: { label: "developers.facebook.com → Mis apps → tu app → Configuración → Básica", url: "https://developers.facebook.com/apps" }
  },
  instagram: {
    title: "Instagram",
    icon: "instagram",
    what: "La app de Instagram Business Login. Con ella, cada empresa conecta su cuenta de Instagram con un clic, sin configurar nada más.",
    where: { label: "developers.facebook.com → tu app → Instagram → Configuración de la API con inicio de sesión de Instagram", url: "https://developers.facebook.com/apps" }
  },
  telegram: {
    title: "Telegram",
    icon: "telegram_user",
    what: "La aplicación de Telegram de tu plataforma. Con ella, cada empresa vincula su cuenta personal de Telegram escaneando un QR. Al guardarla, el canal se activa sin reiniciar el servidor.",
    where: { label: "my.telegram.org → API development tools", url: "https://my.telegram.org/apps" }
  }
};

export const FIELD_LABELS = {
  meta: {
    appId: ["App ID", "Número de identificador de la app de Meta."],
    appSecret: ["App Secret", "Clave secreta de la app (32 caracteres)."],
    fbLoginConfigId: ["Configuración de Facebook Login for Business", "El «config_id» del inicio de sesión para empresas."],
    wabaEsConfigId: ["Configuración del registro integrado de WhatsApp", "El «config_id» del Embedded Signup de WhatsApp."],
    wabaEsEnabled: ["Activar el registro integrado de WhatsApp", "Muestra el botón de Embedded Signup al crear una conexión de WhatsApp oficial. Requiere que Meta haya aprobado la app."],
    webhookVerifyToken: ["Token de verificación del webhook", "El mismo que registraste en Meta para el webhook de la app."],
    wabaDefault2faPin: ["PIN de verificación en dos pasos (WABA)", "6 dígitos. Si lo dejas vacío, se genera uno aleatorio al registrar el primer número."],
    graphVersion: ["Versión de la Graph API", "Por ejemplo v21.0."],
    webhookSignatureRequired: ["Exigir firma en los webhooks de Meta", "Rechaza los webhooks de conexiones sin App Secret."]
  },
  instagram: {
    appId: ["Instagram App ID", "No es el mismo que el App ID de Meta."],
    appSecret: ["Instagram App Secret", "Clave secreta de Instagram (32 caracteres)."],
    redirectUri: ["URL de retorno", "Solo cámbiala si en Meta registraste otra."]
  },
  telegram: {
    apiId: ["api_id", "Número que da Telegram al crear la aplicación."],
    apiHash: ["api_hash", "Clave de 32 caracteres."]
  }
};

export const STATUS_INFO = {
  ready: { label: "Listo", color: "#2e7d32", bg: "#e8f5e9" },
  incomplete: { label: "Incompleto", color: "#b26a00", bg: "#fff4e5" },
  empty: { label: "Sin configurar", color: "#616161", bg: "#f0f0f0" }
};

export const SOURCE_LABEL = {
  panel: "Guardado aquí",
  env: "Desde el archivo de configuración del servidor",
  default: "Valor por defecto",
  none: null
};

const ERRORES = {
  ERR_PLATFORM_VERIFY_FAILED: (d) => d || "El proveedor rechazó las credenciales.",
  ERR_PLATFORM_INVALID_VALUE: (d, provider) => `«${FIELD_LABELS[provider]?.[d]?.[0] || d}» no tiene el formato correcto.`,
  ERR_PLATFORM_INCOMPLETE: (d, provider) =>
    `Falta: ${String(d || "").split(",").map((k) => FIELD_LABELS[provider]?.[k]?.[0] || k).join(", ")}.`,
  ERR_PLATFORM_EMPTY: () => "No hay cambios que guardar.",
  ERR_PLATFORM_NOT_SUPER: () => "Solo el superadministrador puede cambiar esto."
};

export const describeError = (err, provider) => {
  const data = err?.response?.data || {};
  const f = ERRORES[data.error];
  return f ? f(data.detail, provider) : data.error || "No se pudo guardar.";
};
